import Image from 'next/image';
import { useMedia } from 'react-use';

import { breakpoints } from '@/styles/util';

import { Modal } from '@/ui/Modal';
import { BottomPanelModal } from '@/ui/Modal/BottomPanelModal';

interface ZoraImageModalProps {
  isOpen: boolean;
  onClose: () => void;
  imageUrl: string;
  description?: string;
}

export const ZoraImageModal = ({ isOpen, onClose, imageUrl, description }: ZoraImageModalProps) => {
  const isMobile = useMedia(breakpoints.mobile, false);

  const content = (
    <div className="flex flex-col items-center justify-center p-4 md:p-8 focus:outline-none gap-4 mt-2 md:mt-0">
      <div className="relative focus:outline-none">
        <Image
          src={imageUrl}
          alt={description || 'Zora token image'}
          width={1200}
          height={1200}
          className="object-contain rounded-lg focus:outline-none max-w-full max-h-[60vh] md:max-h-[70vh] w-auto h-auto"
          sizes="(max-width: 768px) 100vw, (max-width: 1200px) 80vw, 1200px"
          priority
        />
      </div>
      {description && (
        <div className="max-w-2xl text-center px-4">
          <p className="text-sm md:text-base text-gray-700 dark:text-gray-300 leading-relaxed">
            {description}
          </p>
        </div>
      )}
    </div>
  );

  if (isMobile) {
    return (
      <BottomPanelModal
        isOpen={isOpen}
        onClose={onClose}
        onOpenChange={(open) => !open && onClose()}
      >
        {content}
      </BottomPanelModal>
    );
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className="focus:outline-none focus-visible:outline-none"
    >
      {content}
    </Modal>
  );
};
